/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateNoteRequest = {
    note: string;
    type: CreateNoteRequest.type;
};
export namespace CreateNoteRequest {
    export enum type {
        SELF = 'SELF',
        CENTRAL = 'CENTRAL',
    }
}

